import { lazyWithRetry } from "utils/lazy-with-retry";
import { IDraftsProps } from "./definitions";

const LazyDrafts = lazyWithRetry(() => import("./Drafts"));

const Drafts = (props: IDraftsProps) => <LazyDrafts {...props} />;

export default Drafts;
